import { apiPost } from './client';
import { routes } from './routes';

export async function getUserProfile() {
  try {
    const response = await apiPost(routes.user.profile);
    const data = await response.json();
    return data.userProfile;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
}
